import App from './App';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import registerServiceWorker from './registerServiceWorker';


// Get the application-wide store instance, prepopulating with state from the server where available.
ReactDOM.render(
            <App />
    ,
    document.getElementById('root'));

registerServiceWorker();
